var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.394 3.189 4.25 6.333 2.855 4.937 1.459 3.542l-.708.708-.708.708L2.147 7.06 4.25 9.165 8.105 5.31l3.854-3.854-.705-.706a74 74 0 0 0-.71-.705c-.003 0-1.42 1.415-3.15 3.144",
  clipRule: "evenodd"
})));
export default SvgCheck;